"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _Favorite = _interopRequireDefault(require("@material-ui/icons/Favorite"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _excluded = ["active", "label"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    avatar: {
      backgroundColor: theme.palette.primary.main
    },
    media: {
      paddingTop: '50%'
    }
  };
});

var Favourites = function Favourites(_ref) {
  var active = _ref.active,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Fab["default"], _extends({
    variant: "extended",
    size: "large",
    color: active ? 'primary' : 'white',
    "aria-label": "add",
    className: classes.root,
    classes: {
      root: classes.root,
      label: classes.label
    }
  }, props), /*#__PURE__*/_react["default"].createElement(_Favorite["default"], {
    fontSize: "medium",
    style: {
      marginRight: 8
    }
  }), label);
};

Favourites.propTypes = {
  className: _propTypes["default"].string,
  certificate: _propTypes["default"].object.isRequired,
  results: _propTypes["default"].array.isRequired,
  nbProducts: _propTypes["default"].number.isRequired,
  noMedia: _propTypes["default"].bool.isRequired
};
Favourites.defaultProps = {
  className: '',
  noMedia: false
};
var _default = Favourites;
exports["default"] = _default;